module.exports = __webpack_public_path__ + "img/308.png";